import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-loading-application.component',
  templateUrl: './loading-application.component.html',
  styleUrls: ['./loading-application.component.scss'],
  standalone: false,
})
export class LoadingApplicationComponent {
  constructor() {}
}
